import { reverse } from 'named-urls';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown, ToolbarButton, useMediaQueryContext } from '@fourthwall/components';
import { DotsHorizontalIcon } from '@fourthwall/icons';
import { routing } from '@utils/routing';
export const AppDropdown = ({ app, onDelete }) => {
    const media = useMediaQueryContext();
    const navigate = useNavigate();
    const handleFullEditClick = () => {
        navigate(reverse(routing.settings.platformApps.editApp.self, { appId: app.id }));
    };
    return (React.createElement(Dropdown, { content: React.createElement(React.Fragment, null,
            React.createElement(Dropdown.Item, { label: "Edit", onClick: handleFullEditClick }),
            React.createElement(Dropdown.Item, { label: "Delete", onClick: () => onDelete(app) })), position: "bottom-start" },
        React.createElement(ToolbarButton, { label: "Settings", icon: DotsHorizontalIcon, color: media.tablet ? undefined : 'var(--icon-secondary)' })));
};
